import { AdditionalCriteriaState, StudyStartDateCriteria, BookingSystemCriteria, ProductFilterSection, EmptyCriteria } from "app/pages/DiscountEditor/modules/AdditionalCriteria/state";
import { ProductType } from "app/shared/model";
import { AdditionalCriteriaType } from "app/pages/DiscountEditor/actionTypes";
import { AdditionalCriteriaDto, DateBoundariesFilterDto, BookingSystemFilterDto, RequiredProductsDto, ProductSelectionDto } from "app/shared/model/DiscountDto";
import { productFilterToDto } from "app/shared/model/ProductFilter";
import { unitsFilterToDto } from "app/shared/model/ProductUnitFilter";

function getRoot(state: any) : AdditionalCriteriaState {
    return state.additionalCriteria;
}

export function getAddOrEditModal(state: any) : AdditionalCriteriaType {
    return getRoot(state).addOrEditModal;
}

export function getDeleteConfirmationModal(state: any) : AdditionalCriteriaType {
    return getRoot(state).deleteConfirmationModal
}

export function getStudyStartDateCriteria(state: any) : StudyStartDateCriteria {
    return getRoot(state).studyStartDate; 
}

export function getBookingSystemCriteria(state: any) : BookingSystemCriteria {
    return getRoot(state).bookingSystem; 
}

export function getAdditionalProductFilterType(state: any) {
    const root = getRoot(state);
    const criteria = root.addOrEditModal;
    switch(criteria) {
        case AdditionalCriteriaType.Course:
            return ProductType.Course;
        case AdditionalCriteriaType.Accommodation:
            return ProductType.Accommodation;
        case AdditionalCriteriaType.AddOns:
            return ProductType.AddOn;
        case AdditionalCriteriaType.Transfer:
            return ProductType.Transfer;
        default:
            return undefined;
    }
}

export function getAdditionalProductFilterByType(state: any, type: AdditionalCriteriaType) : ProductFilterSection|EmptyCriteria {
    const root = getRoot(state);
    const productFilters = root.productFilters;
    switch(type) {
        case AdditionalCriteriaType.Course:
            return productFilters.courseFilter;
        case AdditionalCriteriaType.Accommodation:
            return productFilters.accommodationFilter;
        case AdditionalCriteriaType.AddOns:
            return productFilters.addOnsFilter;
        case AdditionalCriteriaType.Transfer:
            return productFilters.transferFilter;
        default:
            return {hasCriteria: false}
    }
}

export function getAdditionalProductFilter(state: any) {
    const root = getRoot(state);
    const criteria = root.addOrEditModal;
    return getAdditionalProductFilterByType(state, criteria);
}


export function getAdditionalCriteriaDto(state: any) : AdditionalCriteriaDto {
    const root = getRoot(state);
    let studyStartDate : DateBoundariesFilterDto|undefined = undefined; 
    let bookingSystem : BookingSystemFilterDto|undefined = undefined; 

    if (root.studyStartDate.hasCriteria) {
        studyStartDate = {
            minDate: root.studyStartDate.minDate,
            maxDate: root.studyStartDate.maxDate
        }
    }

    if (root.bookingSystem.hasCriteria) {
        bookingSystem = {
            bookingSystemIds: root.bookingSystem.selectedSystems.map(x => x.id.toString())
        }        
    }

    return {
        studyStartDate: studyStartDate, 
        bookingSystem: bookingSystem, 
        requiredProducts:  {
            courseFilter: getProductSelectionDto(state, AdditionalCriteriaType.Course), 
            accommodationFilter: getProductSelectionDto(state, AdditionalCriteriaType.Accommodation),
            transferFilter: getProductSelectionDto(state, AdditionalCriteriaType.Transfer),
            addOnFilter: getProductSelectionDto(state, AdditionalCriteriaType.AddOns)
        }
    };
}

function getProductSelectionDto(state: any, type: AdditionalCriteriaType) : ProductSelectionDto|undefined
{
    const filter = getAdditionalProductFilterByType(state, type); 
    if (!filter.hasCriteria)
        return undefined; 

    return {
        productFilter: productFilterToDto(filter.productFilter), 
        unitsFilter: unitsFilterToDto(filter.unitsFilter)
    }
}